<template>
   <div class="print_footer_design_4" id="print_footer_design_4">
      <span class="fw-bold d-inline-block ms-auto me-5 mb-4">{{ $t('lang_the_signature') }}</span>

      <div v-if="shopSecondAddress" class="contact">
         <i class="fa-solid fa-location-dot"></i>
         <span>{{ shopSecondAddress }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center">
         <p v-if="shopNote" class="note">
            <span>
               {{ $t('lang_notes') }} : 
               {{ shopNote }}
            </span>
         </p>
      </div>

      <div :style="$isArb() ? '--rotateY: 0deg' : '--rotateY: 180deg'">
         <span class="design-touch-1" :style="$isArb() ? 'right: unset; left: 20% ' : 'left: unset; right: 20%'"></span>
         <span class="design-touch-2" :style="$isArb() ? 'right: unset; left: 10%'  : 'left: unset; right: 10%'"></span>
         <span class="design-touch-3" :style="$isArb() ? 'right: unset; left: 0%'   : 'left: unset; right: 0%'"></span>
      </div>
   </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useStore } from 'vuex'

export default {
   setup () {
      const store = useStore();
      const shop  = store.getters['shop/getShop'];

      const state = reactive({
         shopAddress: shop.address || false,
         shopSecondAddress: shop.secondaryAddress || false,
         shopNote: shop.note || false,
      });

      return {
         ...toRefs(state),
      }
   }
}
</script>

<style lang="scss" scoped>
@use '@sass/helpers' as *;

.print_footer_design_4 {
   position: relative;
   display: grid;
   gap: rem(5);
   padding: 1rem;
   margin-top: auto;
   font-size: 1rem;

   .design-touch-1,
   .design-touch-2,
   .design-touch-3 {
      position: absolute;
      bottom: 0;
      width: 80px;
      height: 60px;
      clip-path: polygon(0 40%, 50% 0, 100% 100%, 30% 100%);
      transform: rotateY(var(--rotateY));
   }
   
   .design-touch-1 {
      left: 20%;
      background-color: #FEDC54;

   }
   
   .design-touch-2 {
      left: 10%;
      background-color: #A6FBFE;
   }
   
   .design-touch-3.design-touch-3 {
      left: 0%;
      background-color: #FE85AE;
   }
}
</style>